// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-table__row--level-1 {\n    background-color: #f2efef !important;\n    /* 需要设置的背景色 */\n    box-shadow: rgba(232, 232, 232, 0.16) 0px 1px 4px, rgb(232, 232, 232) 0px 0px 0px 3px;\n}\n", ""]);
// Exports
module.exports = exports;
